import { useMemo } from 'react';
import { CheckIcon } from '@heroicons/react/outline';
import { GridColDef } from '@mui/x-data-grid-pro';
import { dataGridCol } from '@shared/components/grid/common';

const getYesNoTitle = (params: { value?: boolean }) =>
  typeof params.value === 'boolean' ? (params.value ? 'Yes' : 'No') : 'N/A';

export const useStateRequirementsColumns = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const columns = useMemo<GridColDef<any, any, any>[]>(
    () => [
      dataGridCol('state', {
        flex: 1,
        minWidth: 100,
        headerName: 'State',
      }),
      dataGridCol('titleHoldingStatus', {
        flex:1,
        minWidth: 100,
        headerName: 'Title Holding',
        renderCell: getYesNoTitle,
      }),
      dataGridCol('isOutOfStateTitleAllowed', {
        flex:1,
        minWidth: 100,
        headerName: 'Out of State Title Allowed',
        renderCell: getYesNoTitle,
      }),
      dataGridCol('addStatus', {
        flex:1,
        minWidth: 100,
        headerName: 'SOR Required - ADD',
        renderCell: getYesNoTitle,
      }),
      dataGridCol('dropStatus', {
        flex:1,
        minWidth: 100,
        headerName: 'SOR Required - DROP',
        renderCell: getYesNoTitle,
      }),
      dataGridCol('notaryRequiredStatus', {
        flex:1,
        minWidth: 100,
        headerName: 'Notary Required',
        renderCell: getYesNoTitle,
      }),
      dataGridCol('salesTaxInformation', {
        flex: 4,
        minWidth: 200,
        headerName: 'Sales Tax Information',
        renderCell: (params: { value?: string }) =>
          params.value ? <div dangerouslySetInnerHTML={{ __html: params.value }} /> : null,
      }),
      dataGridCol('specificRequirements', {
        flex: 4,
        minWidth: 200,
        headerName: 'Specific Requirements',
        renderCell: (params: { value?: string }) =>
          params.value ? (
            <div
              dangerouslySetInnerHTML={{ __html: params.value }}
              style={{ width: '100%', wordBreak: 'break-word' }}
            />
          ) : null,
      }),
      dataGridCol('titleDocuments', {
        flex: 4,
        minWidth: 200,
        headerName: 'Title Documents',
        renderCell: (params: { value?: string }) =>
          params.value ? <div dangerouslySetInnerHTML={{ __html: params.value }} /> : null,
      }),
      dataGridCol('isAllowProductAndSalesTax', {
        flex:1,
        minWidth: 100,
        headerName: 'Allow Product And Sales Tax',
        renderCell: (params: { value?: boolean }) =>
          params.value ? (
            <div style={{ width: '30px', height: '30px' }}>
              <CheckIcon />
            </div>
          ) : null,
      }),
    ],
    [],
  );

  return columns;
};
